<template>
  <div class="chat-log pa-5">
    <div v-for="(message, index) in messages" :key="message.id" class="chat-group d-flex align-start" :class="[
      {
        'flex-row-reverse': message.user.id === user.id,
      },
      {
        'mb-2': true,
      },
    ]">
      <div class="chat-avatar" :class="message.user.id == user.id ? 'ms-3' : 'me-4'">
        <v-avatar color="primary" size="38" v-if="index == 0 || messages[index - 1].user.id !== message.user.id">
          <template v-if="message.user.picture">
            <img :src="message.user.picture" />
          </template>
          <template v-else>
            <v-icon color="white" size="28">{{ icons.mdiAccount }}</v-icon>
          </template>
        </v-avatar>
        <div v-else style="height: 38px; width: 38px"></div>
      </div>

      <div class="chat-body d-inline-flex flex-column"
        :class="message.user.id === user.id ? 'align-end' : 'align-start'">
        <p :key="message.id" class="chat-content py-3 px-4 elevation-1" :class="[
          message.user.id !== user.id
            ? 'bg-card chat-left'
            : 'primary white--text chat-right',
          messages.length - 1 !== index ? 'mb-2' : 'mb-1',
        ]">
          <template v-if="!message.deleted">
            <span v-html="linkifyStr(message.message, {
              target: '_blank'
            })"></span>
          </template>
          <template v-else>
            <i class="text-xs">{{ $t("Viesti poistettu") }}</i>
          </template>
        </p>
        <div v-if="
          index >= messages.length - 1 ||
          message.user.id !== messages[index + 1].user.id
        " :class="{
          'text-right': message.user.id !== user.id,
        }">
          <span class="text-xs me-1 text--disabled">
            {{ message.user.first_name }} {{ message.user.last_name }}
            {{ message.timestamp }}</span>
        </div>
      </div>
      <v-menu bottom left v-if="isManager">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon color="secondary">
              {{ icons.mdiDotsVertical }}
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="deleteMessage(message)">
            <v-list-item-title>{{ $t("Poista viesti") }} </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from "@vue/composition-api";
import { formatDate } from "@core/utils/filter";

import { mdiCheck, mdiCheckAll, mdiAccount, mdiDotsVertical } from "@mdi/js";
import api from "@/api";
import useAuth from "@/useAuth";
import { getDateTime } from "@/@core/utils/datetime_helpers";

import linkifyStr from "linkify-string";

export default {
  props: {
    messages: {
      type: Array,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    chatroom: {
      type: Object,
      required: false,
    },
    isManager: {
      type: Boolean,
      required: false,
    },
    chatData: {
      type: Object,
      required: true,
    },
    profileUserAvatar: {
      type: String,
      required: false,
    },
  },
  setup(props, context) {
    const deleteMessage = (message) => {
      context.emit("on-delete-message", message);
    };

    return {
      deleteMessage,
      linkifyStr,
      icons: {
        mdiCheck,
        mdiDotsVertical,
        mdiCheckAll,
        mdiAccount,
      },
    };
  },
};
</script>
